import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { HttpUrlGenerator } from "@ngrx/data";
import { ApiResponse, RestService } from "@recore-solutions/nstar-lib";
import { Observable, of } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { NstarDataService } from "src/app/nstar-data.service";
import { environment } from "src/environments/environment";
import { OpenHouse } from "./models/OpenHouse";

@Injectable({
	providedIn: "root",
})
export class OpenHouseDataService extends NstarDataService<OpenHouse> {
	constructor(
		protected httpClient: HttpClient,
		protected httpUrlGenerator: HttpUrlGenerator,
		protected restService: RestService
	) {
		super("OpenHouse" as never, httpClient, httpUrlGenerator);
	}

	getOpenHouseApiResponse(queryParams?: Record<string, any>): Observable<OpenHouse[]> {
		queryParams = {
			...queryParams,
		};
		const params = this.queryParamsToHttpParams(queryParams);
		return this.restService
			.get<ApiResponse<OpenHouse>>(environment.endpoints.openHouses, params)
			.pipe(
				map((response) => response?.records || []),
				catchError(() => of([]))
			);
	}

	getAll(): Observable<OpenHouse[]> {
		return this.getOpenHouseApiResponse();
	}

	getWithQuery(params: Record<string, any>): Observable<OpenHouse[]> {
		return this.getOpenHouseApiResponse(params);
	}
}
